import CouponService from "src/services/CouponService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	UPLOAD_IMAGE: "user/edit",
	CHECK_COUPON: "coupon/check",
};
export const params = {};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.user,
 @property  {array}  modules.users
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {
		async [types.CHECK_COUPON] (context, data) {
			const response = await CouponService.isValid(data);
			return response;
		},
	},
	types: types,
};
export default ModuleCreator("coupon", CouponService, module, types, params);
